import React from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
function Banner() {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const slides = [
    {
      img: 'images/slides/slider-mainbg-001.jpg',
      heading: 'Your Partner in Success',
      text: 'NASK International is sourcing and buying agency based in Pakistan. With more than a decade of experience in product sourcing, we are proud to be the partners of some of the world\'s renowned brands. We have a team of skilled professionals who are always ready to assist you with your business needs.',
      btns: true
    },
    {
      img: 'images/slides/slider-mainbg-002.jpg',
      heading: 'Garments & Uniforms',
      text: 'Superior quality garments both woven and knitted. We are experts in producing uniforms and apparel that meet international standards. Our efficient production lines ensure timely delivery with unmatched quality.',
      btns: true
    },
    {
      img: 'images/slides/slider-mainbg-003.jpg',
      heading: 'Home Textiles & Furnishing',
      text: 'We provide a wide variety of home textile products including bedding, curtains, and kitchen linens. Our designs are innovative and tailored to the latest trends in interior decor.',
      btns: true
    },
    {
      img: 'images/slides/slider-mainbg-004.jpg',
      heading: 'Hospitality & Hotel Supplies',
      text: 'Complete solution for hotel, restaurant and institutional supplies. We offer premium-quality items from bedding to amenities, designed specifically for the hospitality industry.',
      btns: true
    },
    {
      img: 'images/slides/slider-mainbg-005.jpg',
      heading: 'Industrial Products',
      text: 'Industrial tools and safety equipment to ensure your operations run smoothly and safely. We cater to industries such as construction, manufacturing, and logistics.',
      btns: true
    }
  ];
  
  return (
<div className="banner_slider_wrapper">
  <div className="slider-textarea">
    <h4>Enquiry Call:+92 305 1115508</h4>
  </div>
  <div className="slider-social-links-wrapper">
    <ul className="social-icons">
      <li className="tm-social-facebook"><a target="_blank" href="https://www.facebook.com/naskinternational/"><i className="fa fa-facebook" /></a></li>
      <li className="tm-social-twitter"><a target="_blank" href="https://twitter.com/PreyanTechnosys"><i className="fa fa-twitter" /></a></li>
      <li className="tm-social-flickr"><a target="_blank" href="	https://www.instagram.com/naskinternational/"><i className="fa-brands fa-instagram" /></a></li>
      <li className="tm-social-linkedin"><a target="_blank" href="https://www.tiktok.com/@naskinternational"><i className="fa-brands fa-tiktok" /></a>
      </li>
      <li className="tm-social-linkedin"><a target="_blank" href="	https://www.youtube.com/channel/UCcUtzsrX2K8mGfiNXW7Kq-g"><i className="fa-brands fa-youtube" /></a></li>
      <li className="tm-social-linkedin"><a target="_blank" href="https://www.pinterest.com/naskinternational/"><i className="fa-brands fa-pinterest-p" /></a></li>
      <li className="tm-social-linkedin"><a target="_blank" href="https://www.linkedin.com/company/nask-international/"><i className="fa fa-linkedin" /></a></li>
    </ul>
  </div>
  <div className="banner_slider banner_slider_wide">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="slide">
            <div
              className="slide_img"
              style={{ backgroundImage: `url(${slide.img})` }}
            />
            <div className="slide__content">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="slide__content--headings ttm-textcolor-white text-center">
                      <h3>Manufacturer | Export | Sourcing | Inspection</h3>
                      <h2>{slide.heading}</h2>
                      <p>{slide.text}</p>
                      {slide.btns && (
                        <div className="d-inline-block margin_top30">
                          <Link className="ttm-btn ttm-btn-color-skincolor margin_right15" to="/about-us">
                            more details
                          </Link>
                          <Link className="ttm-btn ttm-btn-color-white" to="/contact-us">
                            get a quote
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
</div>


  )
}

export default Banner